import { setStore, getStore } from '@/util/store'
import { dateFormat } from '@/util/date'
import { sendLogs } from '@/api/user'
import { getApproveLogs } from '@/api/runActivityManage/activity';

const logs = {
  state: {
    logs: [],
    logsList: getStore({ name: 'logsList' }) || [] // 错误日志列表
  },
  actions: {
    SendLogs ({ state, commit }) {
      return new Promise((resolve, reject) => {
        sendLogs(state.logsList).then(() => {
          commit('CLEAR_LOGS')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取审批操作日志
    getApproveLogs({ commit }, payload) {
      return getApproveLogs(payload).then(response => {
        const res = response.data;
        if (res.code === 200) {
          commit('UPDATE_LOGS', res.data || []);
        }
      })
    },
  },
  mutations: {
    UPDATE_LOGS: (state, list) => {
      state.logs = list;
    },
    ADD_LOGS: (state, { type, message, stack, info }) => {
      state.logsList.push(Object.assign({
        url: window.location.href,
        time: dateFormat(new Date())
      }, {
        type,
        message,
        stack,
        info: info.toString()
      }))
      setStore({name: 'logsList', content: state.logsList})
    },
    CLEAR_LOGS: (state) => {
      state.logsList = []
      setStore({name: 'logsList', content: state.logsList})
    }
  }
}

export default logs
